/* Excel roles loader (TypeScript) */
/* global Excel */
import { Constants } from "../constants/constants";
const TARGET_SHEET = Constants.Roles_MasterSheet_Name;
export async function loadRolesSheet() {
    return Excel.run(async (context) => {
        const sheets = context.workbook.worksheets;
        sheets.load("items/name");
        await context.sync();
        const match = sheets.items.find((s) => s.name.toLowerCase() === TARGET_SHEET.toLowerCase());
        if (!match) {
            console.warn(`Sheet '${TARGET_SHEET}' not found.`);
            return;
        }
        let values = [];
        try {
            const used = match.getUsedRange();
            used.load("values");
            await context.sync();
            values = used.values || [];
        }
        catch {
            const fb = match.getRange(Constants.Roles_MasterSheet_Range);
            fb.load("values");
            await context.sync();
            values = fb.values || [];
        }
        if (!values.length) {
            console.warn("Roles sheet empty.");
            return;
        }
        // The roles sheet has two columns: RoleID (col 0) and RoleName (col 1).
        // No header row expected based on user data — first row is data.
        // If a header row exists (non-numeric first cell), skip it.
        let startRow = 0;
        const firstCell = String(values[0][0] || "").trim();
        if (firstCell && isNaN(Number(firstCell))) {
            startRow = 1; // Skip header row
        }
        const roles = [];
        const byRoleId = {};
        const byRoleName = {};
        for (let r = startRow; r < values.length; r++) {
            const row = values[r];
            if (!row)
                continue;
            const id = String(row[0] || "").trim();
            const name = String(row[1] || "").trim();
            if (!id || !name)
                continue;
            const role = { id, name };
            roles.push(role);
            byRoleId[id] = role;
            byRoleName[name.toLowerCase()] = role;
        }
        window.__rolesList = {
            sourceSheet: match.name,
            roles,
            byRoleId,
            byRoleName,
        };
    });
}
